import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const TipoConvenioEvitarDobleImposicionFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Tipo Conventio para evitar doble imposición' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='tipoConvenioEvitarDobleImposicion'>
          {({ field }) => (
            <Form.InputText {...field} id='input-tipoConvenioEvitarDobleImposicion' isInvalid={iError && iTouched} disabled={fIsSubmitting} />
          )}
        </Field>
        {iError && iTouched ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoConvenioEvitarDobleImposicionFormGroup)
